import api from './interceptor';

const BASE_URL_V2 = 'api/v2/timezones';

export default {
  // API Version 2
  setAccountTimezone: (params) => api.put(`${BASE_URL_V2}`, params),
  getTimezones: () => api.get(`${BASE_URL_V2}`),
};
